// ========================================
// Toast Manager
// Handles toast notifications
// ========================================

const ToastManager = {
    /**
     * Show toast notification
     */
    showToast(message, type = 'info', duration = 3000) {
        const container = document.getElementById('toast-container');
        if (!container) {
            console.error('Toast container not found');
            return;
        }

        const toast = document.createElement('div');
        toast.className = `toast toast-${type}`;

        const iconMap = {
            'success': 'fa-check-circle',
            'error': 'fa-exclamation-circle',
            'warning': 'fa-exclamation-triangle',
            'info': 'fa-info-circle'
        };

        const icon = iconMap[type] || iconMap.info;

        SafeHTML.set(toast, `
            <i class="fas ${icon}"></i>
            <span>${message}</span>
        `);

        container.appendChild(toast);

        // Auto-remove after duration
        setTimeout(() => {
            toast.style.animation = 'slideInRight 0.3s ease reverse';
            setTimeout(() => toast.remove(), 300);
        }, duration);
    },

    /**
     * Show success toast
     */
    showSuccess(message, duration = 3000) {
        this.showToast(message, 'success', duration);
    },

    /**
     * Show error toast
     */
    showError(message, duration = 4000) {
        this.showToast(message, 'error', duration);
    },

    /**
     * Show warning toast
     */
    showWarning(message, duration = 3500) {
        this.showToast(message, 'warning', duration);
    },

    /**
     * Show info toast
     */
    showInfo(message, duration = 3000) {
        this.showToast(message, 'info', duration);
    }
};

// Make ToastManager globally available
window.ToastManager = ToastManager;
